import * as React from "react"
import PropTypes from "prop-types"

import { useStaticQuery, graphql, Link } from "gatsby"
import { css } from "@emotion/react"
import { StaticImage } from "gatsby-plugin-image"
import SocialIcons from "./socialIcons"
import StoreButtons from "./storeButtons"
import madbox from "../images/madbox.svg"

const Footer = ({ globals }) => {
  const dataDefault = useStaticQuery(graphql`
    query footerDefaultQuery {
      prismicGlobals(lang: { eq: "en-us" }) {
        data {
          footer_title
          footer_subtitle
          copyright
          store {
            link
            store_id
          }
          social {
            link
            social_id
          }
        }
      }
    }
  `)

  const footerData = globals ? globals : dataDefault.prismicGlobals

  return (
    <footer className="  bg-white rounded-t-2xl    md:bg-gradient-to-r md:from-neutral-100 md:to-white  md:pb-0">
      <div className="container flex flex-col flex-wrap items-center mx-auto md:flex-row">
        <div className="flex flex-col flex-1 m-8 pb-8   md:order-2 md:w-1/5 md:justify-center md:items-start md:pl-10 md:bg-white md:rounded-3xl md:shadow-[-5px_0px_10px_1px_rgba(156,163,175,0.1)]">
          <div className="text-center   md:w-1/3 md:order-2 md:mt-5">
            <h5 className="text-2xl font-sans font-semibold">
              {footerData.data?.footer_title}
            </h5>
            <p>{footerData.data?.footer_subtitle}</p>
            <div className="flex justify-center mt-5">
              <SocialIcons isDark />
            </div>
          </div>
          <div className="text-center md:w-2/3 md:order-1 pt-5">
            <StoreButtons globals={footerData} />
          </div>
        </div>
        <div className=" flex-1 items-center mt-5 px-8    md:px-32 md:order-1">
          <div className="flex ">
            <div className="flex-1 mr-2">
              <a href="https://madbox.io/" target="_blank" rel="noreferrer">
                <img src={madbox} alt={"madbox website"} />
              </a>
            </div>
            <div className="flex-1 ml-2 sm:pr-6">
              <p className="text-sm text-neutral-500">
                {footerData.data?.copyright}
              </p>
            </div>
          </div>
          <ul className="mt-10 hidden text-neutral-500   md:flex">
            <li className="pr-5">
              <a
                href="https://www.madbox.io/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li className="pr-5">
              <a
                href="https://www.madbox.io/terms"
                target="_blank"
                rel="noreferrer"
              >
                Terms
              </a>
            </li>
            <li className="pr-5">
              <a
                href="https://www.madbox.io/games"
                target="_blank"
                rel="noreferrer"
              >
                Games
              </a>
            </li>
            <li className="pr-5">
              <Link to={"/blog"}>Blog</Link>
            </li>
            <li className="pr-5">
              <a
                href="https://drive.google.com/drive/u/0/folders/1CZiGzgCGEhzXQ48X1WjKtU3sKVqdlPqD"
                target="_blank"
                rel="noreferrer"
              >
                Press Kit
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="relative h-36 sm:h-24   ">
        <div className="absolute z-10 bottom-0 sm:hidden">
          <StaticImage src="../images/background/background-sm.png" alt="" />
        </div>
        <div className="hidden absolute z-10 bottom-0    sm:block md:hidden">
          <StaticImage src="../images/background/background-md.png" alt="" />
        </div>
        <div className="hidden absolute z-10 bottom-0    md:block lg:hidden">
          <StaticImage src="../images/background/background-lg.png" alt="" />
        </div>
        <div className="hidden absolute z-10 bottom-0    lg:block xl:hidden">
          <StaticImage src="../images/background/background-xl.png" alt="" />
        </div>
        <div className="hidden absolute z-10 bottom-0    xl:block 2xl:hidden">
          <StaticImage src="../images/background/background-2xl.png" alt="" />
        </div>
        <div className="hidden absolute z-10 bottom-0 right-0    2xl:block">
          <StaticImage src="../images/background/background-huge.png" alt="" />
        </div>
        <div
          className="absolute z-20 bottom-2 right-1  w-24 
          sm:bottom-3 sm:right-3 sm:w-32
          md:bottom-4 md:right-4 md:w-36
          lg:bottom-8 lg:right-16 lg:w-36 
          xl:bottom-8 xl:right-24 xl:w-40
          2xl:bottom-18 2xl:right-36 2xl:w-48
          "
        >
          <StaticImage src="../images/background/tree.png" alt="" />
        </div>
      </div>
    </footer>
  )
}

const cssBackgroundArea = css`
  grid-area: 1/1;
`

Footer.propTypes = {
  globals: PropTypes.object.isRequired,
}

export default Footer
